export default __webpack_public_path__ + "static/media/interatomic-distance.14a849a9.png";